import { render, staticRenderFns } from "./SettlementsHistoryPopup.vue?vue&type=template&id=2dcad23a&"
import script from "./SettlementsHistoryPopup.vue?vue&type=script&lang=js&"
export * from "./SettlementsHistoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports